import React, { useContext, useEffect,useState } from "react";
import { Link } from "react-router-dom";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { PublicApi } from "api/api";
import { useTranslation } from "react-i18next"; 
import { CommonDataContext } from "contexts/CommonDataContext/CommonDataContext";

const publicApi = new PublicApi()

function Countries() {
  // const countries = [
  //   { name: "Bosnia and Herzegovina", page: "/country/macedonia" },
  //   { name: "Kosovo", page: "/country/macedonia", tooltip: "This designation is without prejudice to positions on status and is in line with UNSCR 1244/1999 and the ICJ Opinion on the Kosovo Declaration of Independence." },
  //   { name: "Montenegro", page: "/country/macedonia" },
  //   { name: "North Macedonia", page: "/country/macedonia" },
  //   { name: "Serbia", page: "/country/macedonia" },
  // ];
  const {  t } = useTranslation();

  const [countryList,setCountryList] = useState([]);
  const context = useContext(CommonDataContext)
  
 

  const getAllCountry = async () => {
 
   setCountryList(context?.countries?.map(country => {
    return {key:country.id,name:country?.name,page:`country/${country?.name}`,tooltip : country?.name === 'Kosovo' &&  t("home:countries:kosovo-tooltip","This designation is without prejudice to positions on status and is in line with UNSCR 1244/1999 and the ICJ Opinion on the Kosovo Declaration of Independence.") }
   }))
    return context?.countries;
  }

  useEffect(() => {
    getAllCountry()
  },[context])

  return (
    <section className="countries-group">
      {countryList.map((country, index) => {
        // ✅ Generate translation key: "country.serbia", "country.bosnia-and-herzegovina", etc.
        const countryKey = `country:${country?.name
          ?.toLowerCase()
          .replace(/\s+/g, "-")}`;

        // ✅ Translate or fallback to original
        const translatedCountry = t(countryKey, country?.name);


        return country.tooltip ? (
          <OverlayTrigger
            key={index}
            placement="top"
            overlay={<Tooltip id="tooltip">{country.tooltip}</Tooltip>}
          >
            <Link to={country.page}>
              <span>*</span>
              {/* {country.name} */}
              {translatedCountry}
              <img src="/images/svg/right-arrow-black.svg" alt="arrow" />
            </Link>
          </OverlayTrigger>
        ) : (
          <Link to={country.page} key={index}>
            {/* {country.name} */}
            {translatedCountry}
            <img src="/images/svg/right-arrow-black.svg" alt="arrow" />
          </Link>
        )
      })}
    </section>
  );
}

export default Countries;
